import { motion } from "framer-motion";
import { Award, ShieldCheck, Baby, Factory, Users, Clock } from "lucide-react";

const features = [
  {
    icon: Award,
    title: "Premium Quality Materials",
  },
  {
    icon: ShieldCheck,
    title: "Australian Standards & Warranty",
  },
  {
    icon: Baby,
    title: "Kids & Pet Friendly",
  },
  {
    icon: Factory,
    title: "Factory Direct Pricing",
  },
  {
    icon: Users,
    title: "Trusted by Trade & Homeowners",
  },
  {
    icon: Clock,
    title: "Fast Quote Turnaround",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5 },
  },
};

export function ValuePropositions() {
  return (
    <section className="section-padding bg-muted/30">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12 text-center"
        >
          <h2 className="mb-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Why Choose Supreme Turf?
          </h2>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          className="grid grid-cols-2 gap-6 md:grid-cols-3 lg:grid-cols-6"
        >
          {features.map((feature) => (
            <motion.div
              key={feature.title}
              variants={itemVariants}
              className="group flex flex-col items-center text-center"
            >
              <motion.div
                whileHover={{ scale: 1.1, rotate: 5 }}
                transition={{ type: "spring", stiffness: 300 }}
                className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary transition-colors group-hover:bg-primary group-hover:text-primary-foreground"
              >
                <feature.icon className="h-7 w-7" />
              </motion.div>
              <h3 className="text-sm font-bold text-foreground leading-tight">
                {feature.title}
              </h3>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
